module.exports = __webpack_public_path__ + "img/avax_logo.0c249d20.webp";